import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { openDialog, closeDialog } from '../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { OperacionesFumigadoView } from '../components/OperacionesFumigadoView'
import { OperacionEliminarFumigado } from '../operacionEliminarFumigado/containers/OperacionEliminarFumigado'
import { OperacionModificarFumigado } from '../operacionModificarFumigado/containers/OperacionModificarFumigado'
import { OperacionNuevoFumigado } from '../operacionNuevoFumigado/containers/OperacionNuevoFumigado'

export const OperacionesFumigado = connect(null, { openDialog, closeDialog })(
  memo(({ silo, openDialog, closeDialog }) => (
    <OperacionesFumigadoView
      silo={silo}
      openDialogNuevoFumigado={() => openDialog(() => <OperacionNuevoFumigado silo={silo} />, 'FUMIGADO_SILO')}
      openDialogModificacionFumigado={() => openDialog(() => <OperacionModificarFumigado silo={silo} />, 'MODIFICAR_FUMIGADO_SILO')}
      openDialogEliminarUltimoFumigado={() => openDialog(() => <OperacionEliminarFumigado silo={silo} />, 'ELIMINAR_FUMIGADO_SILO')}
      cancelar={useCallback(() => {
        closeDialog('OPERACIONES_DE_FUMIGADO_DE_SILO')
      }, [closeDialog])}
    />
  ))
)
